/**
 * The two things a 403 can mean, kept in one place because two independent paths render them.
 *
 * A refusal is announced by the *action's own* handler (`showErrorUnless422`), which has a title
 * worth reading — "Sign-off failed" beats "Permission Denied". A role change is announced by the
 * global 403 handler, which is the only place that can actually tell one happened. Splitting them
 * this way is what stops a plain refusal from claiming someone changed your access (ORB-698).
 */

/** Shown when the user tried something their current role does not allow. */
export const ACTION_NOT_PERMITTED_MESSAGE =
  'You do not have permission to do this. Ask a workspace admin if that looks wrong.'

/** Shown only when a profile refresh proves the user's roles really did change mid-session. */
export const ACCESS_CHANGED_TITLE = 'Your access has changed'
export const ACCESS_CHANGED_MESSAGE =
  'Your permissions were updated by an admin. The page now reflects your current access.'

/** Shown when a Draft asset is opened by anyone who cannot take it into the builder. */
export const DRAFT_NOT_REVIEWABLE_TITLE = 'Nothing to review yet'
export const DRAFT_NOT_REVIEWABLE_MESSAGE =
  'This asset is still a draft. There will be something to review once the team publishes a version.'
